import React, { useContext } from "react";
import { MenuButton, Menu, MenuTitle, MenuItem } from "monday-ui-react-core";
import Home from "monday-ui-react-core/dist/icons/Home";
import Info from "monday-ui-react-core/dist/icons/Info";
import Email from "monday-ui-react-core/dist/icons/Email";
import Duplicate from "monday-ui-react-core/dist/icons/Duplicate";
import Page from "monday-ui-react-core/dist/icons/Page";
import { LicenceContext } from "../licence/LicenceBar";
import { copyTextToClipboard } from "../tools";

import styles from "./TopMenu.module.css";

const TopMenuFunnels: React.FC<any> = function () {
    const { licence } = useContext(LicenceContext);

    const docsUrl = "https://omnitas.dev/monday/funnels";
    const omnitasUrl = "https://omnitas.se";
    const supportUrl = `mailto:support@omnitas.dev?subject=Funnels for Monday.com ${
        licence ? "(" + licence.id + ")" : ""
    }`;

    const openBlankTab = (url: string) => (): void => {
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.rel = "noopener";
        a.click();
    };

    return (
        <div className={styles.wrapper}>
            <MenuButton
                id="menu"
                size={MenuButton.sizes.MEDIUM}
                component={Info}
                closeDialogOnContentClick
                dialogPaddingSize={MenuButton.paddingSizes.MEDIUM}
                dialogPosition={MenuButton.dialogPositions.BOTTOM_START}
                dialogOffset={{ main: 0, secondary: 0 }}
                ariaLabel="Menu"
            >
                <Menu id="menu" size={Menu.sizes.LARGE}>
                    <MenuTitle caption="Funnels by Omnitas.dev" captionPosition={MenuTitle.positions.TOP} />
                    <MenuItem
                        icon={Page}
                        iconType={MenuItem.iconType.SVG}
                        title="Documentation"
                        onClick={openBlankTab(docsUrl)}
                    />
                    <MenuItem
                        icon={Email}
                        iconType={MenuItem.iconType.SVG}
                        title="Email Support"
                        onClick={openBlankTab(supportUrl)}
                    />
                    <MenuItem
                        icon={Home}
                        iconType={MenuItem.iconType.SVG}
                        title="Omnitas Consulting"
                        onClick={openBlankTab(omnitasUrl)}
                    />
                    {licence && <MenuTitle caption="Licence id:" captionPosition={MenuTitle.positions.BOTTOM} />}
                    {licence && <MenuItem icon={Duplicate} title={licence.id} classname={styles.licence} onClick={(): void => copyTextToClipboard(licence.id)} />}
                </Menu>
            </MenuButton>
        </div>
    );
};

export default TopMenuFunnels;
